import { useEffect, useRef } from 'react';

interface SEOJsonLdProps {
  /** Unique DOM id for this script tag — ensures cleanup on unmount */
  id: string;
  data: object | object[];
}

/**
 * Injects a <script type="application/ld+json"> into <head>.
 * Cleaned up automatically when the component unmounts.
 */
const SEOJsonLd = ({ id, data }: SEOJsonLdProps) => {
  const serialized = JSON.stringify(data);
  const idRef = useRef(id);

  useEffect(() => {
    const existing = document.getElementById(idRef.current);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = idRef.current;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(idRef.current);
      if (el) el.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);

  return null;
};

export default SEOJsonLd;
